import {
  User, Briefcase, Home, Landmark, Car, Repeat, HeartPulse, ShieldCheck,
  CarFront, CreditCard, Gauge, TrendingUp, Zap, HandHeart, Headset,
  FileText, SearchCheck, Users, BadgeCheck, Bike, Phone, Mail, MapPin,
  ArrowRight, Check, Wallet, Building2, LineChart, Clock, Lock, ShieldAlert,
} from "lucide-react";

export const iconMap = {
  User, Briefcase, Home, Landmark, Car, Repeat, HeartPulse, ShieldCheck,
  CarFront, CreditCard, Gauge, TrendingUp, Zap, HandHeart, Headset,
  FileText, SearchCheck, Users, BadgeCheck, Bike, Phone, Mail, MapPin,
  ArrowRight, Check, Wallet, Building2, LineChart, Clock, Lock, ShieldAlert,
};

export function Icon({ name, className }) {
  const Cmp = iconMap[name] || Wallet;
  return <Cmp className={className} />;
}
